import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { headers } from '@domains/shared/domain/utils/global-constants';
import { webApiUrl } from '@domains/shared/domain/utils/url';
import { Operation } from 'fast-json-patch';
import { Observable } from 'rxjs';
import { UserDetailBackofficeModel } from '../../models/user-detail-backoffice.model';

@Injectable({
  providedIn: 'root'
})
export class BackofficeUserService {

  private baseUrl = `${webApiUrl}/backoffice/User`;

  constructor(
    private http: HttpClient,
  ) { }

  sendRegisterEmail(userId: string, url: string = `${this.baseUrl}/${userId}/reinvitation`): Observable<void> {
    return this.http.post<void>(url, {}, { headers });
  }

  // E-mail se kóduje — nezakódovaný '#' URL utne a '?' z ní udělá query string,
  // takže backend zkontroloval jinou adresu a odpověděl, že ji lze použít.
  canEmailBeUsedToCreateNewAccount(email: string, url: string = `${this.baseUrl}/Check/${encodeURIComponent(email)}/`): Observable<boolean> {
    return this.http.get<boolean>(url, { headers });
  }

  getUser(userId: string): Observable<UserDetailBackofficeModel> {
    const url = `${this.baseUrl}/${userId}`;
    return this.http.get<UserDetailBackofficeModel>(url, { headers });
  }

  patch(patch: Operation[], id: string, url: string = `${this.baseUrl}/${id}`): Observable<UserDetailBackofficeModel> {
    return this.http.patch<UserDetailBackofficeModel>(url, patch, { headers });
  }

  // Role se posílají celé — jeden uživatel může být admin i student zároveň.
  setRoles(userId: string, roles: string[], url: string = `${this.baseUrl}/${userId}/roles`): Observable<UserDetailBackofficeModel> {
    return this.http.put<UserDetailBackofficeModel>(url, { roles }, { headers });
  }

  // Backend odmítne uživatele zapsaného v kurzu (400) — smí se jen deaktivovat.
  deleteUser(userId: string, url: string = `${this.baseUrl}/${userId}`): Observable<void> {
    return this.http.delete<void>(url, { headers });
  }
}
